import React from "react";
import { img } from "../../App/Landing/landingContent";
import { Icon } from "./Icon";
import Reveal from "./Reveal";

export default function CTASection() {
  return (
    <section id="quote" className="relative overflow-hidden bg-gradient-to-r from-brand-dark via-brand to-[#2B7BFF] text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid md:grid-cols-2 items-center gap-8">
        <Reveal anim="left" className="py-12">
          <h2 className="display text-3xl sm:text-4xl">Ready to Bring Your Ideas to Life?</h2>
          <p className="mt-3 text-sm sm:text-base text-white/90">Custom banners, yard signs and foam core prints — printed for your goals.</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href="#products" className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-brand hover:bg-brand-soft">
              Shop Print Products <Icon name="arrow" className="h-4 w-4" />
            </a>
          </div>
        </Reveal>
        <Reveal anim="right" delay={120} className="relative flex justify-end">
          <img src={img("connect-bg.png")} alt="Custom printed banner on display" loading="lazy" className="block" />
        </Reveal>
      </div>
    </section>
  );
}
